<template>
  <div class="day-detail">
    <div class="info-box">
      <div class="table-title">收益详情数据</div>
      <div class="content">
        <div class="btn-label">
          <span
            :class="{ active: activeLabel == index }"
            v-for="(label, index) in labelArr"
            :key="index"
            @click="changeLabel(index)"
            >{{ label }}</span
          >
        </div>
        <div class="filter-type" v-if="activeLabel">
          <div
            class="type-box"
            v-for="(type, index) in typeDropArr"
            :key="index"
            @click="openTypePicker(index)"
          >
            <span>{{ type.name }}</span>
            <span class="drop-down">{{ type.value | regroupType(index) }}</span>
          </div>
        </div>
        <div class="select-date">
          <span>选择日期</span>
          <div class="date-wrap">
            <div class="select-box">
              <div @click="openDataPickerFn(0)">
                {{ dayTime[0] | regroupDate }} <i>▲</i>
              </div>
              <span>—</span>
              <div @click="openDataPickerFn(1)">
                {{ dayTime[1] | regroupDate }} <i>▼</i>
              </div>
            </div>
            <span class="btn-query" @click="queryTableFn">查找</span>
          </div>
        </div>
      </div>
    </div>

    <div class="table-area">
      <Table
        class="table-data"
        :tableData="activeLabel ? tableDataBill : tableDataDay"
        :tableField="activeLabel ? tableFieldBill : tableFieldDay"
        :closePop="closePop"
        :activeType="activeLabel ? 1 : 0"
      ></Table>
      <van-loading
        class="img-loading"
        type="spinner"
        color="#fd9b21"
        size="24px"
        v-show="loading"
      />
    </div>

    <Pagination
      :tableInfo="tableInfo"
      @changCurrentPage="changCurrentPage"
    ></Pagination>

    <van-popup v-model="isShowTypePicker" position="bottom">
      <van-picker
        value-key="name"
        :columns="pickerOption"
        @change="onConfirmType"
      />
    </van-popup>
    <van-popup v-model="isShowDataPicker" position="bottom">
      <van-datetime-picker
        active-class="active-date"
        v-model="currentDate"
        type="date"
        confirm-button-text="完成"
        :title="datePickerTitle"
        :max-date="maxDate"
        @confirm="confirmDateFn"
        @cancel="isShowDataPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Table from '../table';
import Pagination from '../pagination';
import { getIncomeDayList, getIncomeBillList } from '@/api/income';
export default {
  components: {
    Table,
    Pagination,
  },
  props: {
    closePop: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      labelArr: ['每日账单', '收益详情'],
      activeLabel: 0,
      isShowTypePicker: false,
      vid: 1,
      minDate: new Date(new Date() - 3600 * 1000 * 24 * 365),
      maxDate: new Date(new Date() - 3600 * 1000 * 24 * 1),
      tableDataDay: [],
      tableDataBill: [],
      tableFieldDay: [
        { label: '日期', prop: 'date' },
        { label: '', prop: '' },
        {
          label: '迷你豆数量',
          prop: 'minibean',
          explain: '玩家使用迷你豆购买了作品或资源',
        },
        {
          label: '迷你点数量',
          prop: 'minipoint',
          explain: '玩家使用迷你点购买了作品或资源',
        },
        {
          label: '广告收入',
          prop: 'ad_income',
          explain:
            '玩家在作品或资源中观看了广告 (广告收入需要2日后进账，请以实际进账金额为准)',
        },
        {
          label: '广告展示次数',
          prop: 'ad_count',
          explain: '在所有作品和资源中广告被观看的次数',
        },
        {
          label: '贡献点数量',
          prop: 'contribution',
          explain: '平台为作品支付的服务费',
        },
        {
          label: '其他收入',
          prop: 'other',
          explain: '参加活动、赛事获得奖金收益或激励收益',
        },
      ],
      tableFieldBill: [
        { label: '日期', prop: 'date' },
        { label: '', prop: '' },
        {
          label: '货币类型',
          prop: 'money_type',
        },
        {
          label: '收益来源',
          prop: 'income_type',
        },
        {
          label: '数额',
          prop: 'num',
        },
      ],
      moneyTypeArr: [
        { id: 999, name: '全部' },
        { id: 4, name: '迷你点' },
        { id: 2, name: '迷你豆' },
        { id: 3, name: '广告' },
        { id: 1, name: '贡献点' },
        { id: 5, name: '其他' },
      ],
      incomeTypeArr: [
        { id: 999, name: '全部' },
        { id: 1, name: '地图' },
        { id: 2, name: '资源' },
        { id: 3, name: '其他' },
      ],
      typeDropArr: [
        { name: '货币类型', value: 999 },
        { name: '收益来源', value: 999 },
      ],
      pickerOption: [],
      pickerNum: 0, // 记录当前是货币类型/收益来源
      isShowDataPicker: false,
      currentDate: '',
      dateInputNum: 0, // 记录当前是开始/结束
      datePickerTitle: '开始时间',
      dayTime: [
        new Date(new Date() - 3600 * 1000 * 24 * 7),
        new Date(new Date() - 3600 * 1000 * 24 * 1),
      ],
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      loading: false,
    };
  },
  watch: {
    activeLabel(val) {
      this.typeDropArr = [
        { name: '货币类型', value: 999 },
        { name: '收益来源', value: 999 },
      ];
      this.dayTime = [
        new Date(new Date() - 3600 * 1000 * 24 * 7),
        new Date(new Date() - 3600 * 1000 * 24 * 1),
      ];
      this.tableInfo.page = 1;
      val ? this.fetchIncomeBillList() : this.fetchIncomeDayList();
    },
  },

  filters: {
    regroupType(val, index) {
      let txt = '';
      if (index) {
        switch (val) {
          case 1:
            txt = '地图';
            break;
          case 2:
            txt = '资源';
            break;
          case 3:
            txt = '其他';
            break;
          case 999:
            txt = '全部';
            break;
          default:
            break;
        }
      } else {
        switch (val) {
          case 1:
            txt = '贡献点';
            break;
          case 2:
            txt = '迷你豆';
            break;
          case 3:
            txt = '广告';
            break;
          case 4:
            txt = '迷你点';
            break;
          case 5:
            txt = '其他';
            break;
          case 999:
            txt = '全部';
            break;
          default:
            break;
        }
      }
      return txt;
    },
    regroupDate(val) {
      let time = new Date(val);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
  },
  mounted() {
    this.fetchIncomeBillList();
    this.fetchIncomeDayList();
  },
  methods: {
    changeLabel(index) {
      sessionStorage.setItem('activeLabel', index);
      this.activeLabel = index;
      this.activeLabel ? this.billDetailShow() : this.dailyBillShow();
    },
    billDetailShow() {
      //收益详情曝光埋点
      this.$log('billing_details_show', 85423, { v7: 2 });
    },
    dailyBillShow() {
      //每日账单曝光埋点
      this.$log('daily_billing_show', 85427, { v7: 2 });
    },
    async fetchIncomeDayList() {
      let time = [
        new Date(this.dayTime[0].toString()).getTime() / 1000,
        new Date(this.dayTime[1].toDateString()).getTime() / 1000 +
          24 * 60 * 60 -
          1,
      ];
      try {
        this.loading = true;
        let data = {
          start_time: time[0],
          end_time: time[1],
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
        };
        const res = await getIncomeDayList(data);
        this.loading = false;
        this.tableDataDay = res.data.list;
        this.tableInfo.total = res.data.total_count;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async fetchIncomeBillList() {
      let time = [
        new Date(this.dayTime[0].toString()).getTime() / 1000,
        new Date(this.dayTime[1].toDateString()).getTime() / 1000 +
          24 * 60 * 60 -
          1,
      ];
      try {
        this.loading = true;
        let data = {
          start_time: time[0],
          end_time: time[1],
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
          money_type: this.typeDropArr[0].value,
          income_type: this.typeDropArr[1].value,
        };
        const res = await getIncomeBillList(data);
        this.loading = false;
        this.tableDataBill = res.data.list;
        this.tableInfo.total = res.data.total_count;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    fetchIncomeList() {
      if (this.typeDropArr[0].value === 999) this.vid = 1;
      else {
        this.vid = this.vid + 1;
      }
      //账单详情查询埋点
      this.$log('billing_details_click', 85424, { v7: 2, v8: this.vid });
      this.fetchIncomeBillList();
    },
    fetchDayList() {
      //每日账单查询埋点
      this.$log('daily_billing_check_click', 85428, { v7: 2 });
      this.fetchIncomeDayList();
    },
    changCurrentPage(page) {
      this.tableInfo.page = page;
      this.activeLabel ? this.fetchIncomeBillList() : this.fetchIncomeDayList();
    },
    queryTableFn() {
      this.tableInfo.page = 1;
      this.activeLabel ? this.fetchIncomeList() : this.fetchDayList();
    },
    // 打开类型选择
    openTypePicker(index) {
      index
        ? (this.pickerOption = this.incomeTypeArr)
        : (this.pickerOption = this.moneyTypeArr);
      this.pickerNum = index;
      this.isShowTypePicker = true;
    },
    // 确认类型选择
    onConfirmType(picker, value) {
      this.typeDropArr[this.pickerNum].value = value.id;
      this.isShowTypePicker = false;
    },
    // 打开选择时间
    openDataPickerFn(index) {
      this.dateInputNum = index;
      index
        ? (this.datePickerTitle = '结束时间')
        : (this.datePickerTitle = '开始时间');
      this.currentDate = this.dayTime[index];
      this.isShowDataPicker = true;
    },
    // 确认选择时间
    confirmDateFn(date) {
      let timeArr = [];
      if (this.dateInputNum) {
        timeArr[1] = date;
        timeArr[0] = this.dayTime[0].getTime();
      } else {
        timeArr[0] = date;
        timeArr[1] = this.dayTime[1].getTime();
      }
      if (timeArr[0] > timeArr[1]) {
        this.$Toast('结束日期不能在开始日期之前');
      } else {
        this.dayTime[this.dateInputNum] = date;
        this.isShowDataPicker = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.day-detail {
  font-size: 24px;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 10px;
  .table-title {
    font-size: 28px;
    margin-bottom: 31px;
  }
  .info-box {
    padding-left: 12px;
  }
}

.content {
  .btn-label {
    margin-bottom: 30px;
    span {
      font-size: 26px;
      padding: 10px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      margin-right: 9px;
    }
    .active {
      background: #fffaed;
      border: 1px solid #ffc973;
      color: #fd9b21;
    }
  }
  .select-date {
    font-size: 26px;
    display: flex;
    align-items: center;

    .date-wrap {
      flex: 1;
      height: 56px;
      margin-left: 20px;
      display: flex;
      justify-content: space-between;
      .select-box {
        flex: 1;
        border: 1px solid #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 4px;
        padding-left: 10px;
        div {
          i {
            color: #bfbfbf;
            font-size: 24px;
          }
        }
        span {
          color: #bfbfbf;
        }
      }
      .btn-query {
        width: 90px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background: #f5f5f5;
        border: 1px solid #d9d9d9;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        margin-left: -2px;
      }
    }
  }
  .filter-type {
    font-size: 26px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .type-box {
      margin-right: 40px;
      display: flex;
      align-items: center;
      .drop-down {
        display: block;
        margin-left: 20px;
        width: 160px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
      }
    }
  }
}
.table-area {
  position: relative;
  display: flex;
  flex-direction: column;
  .table-data {
    min-height: 200px;
  }
  .img-loading {
    z-index: 100;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -12px;
  }
}

::v-deep .van-ellipsis {
  font-size: 30px;
}
::v-deep .van-picker__toolbar {
  height: 80px;
  button {
    color: #262626;
    font-size: 28px;
  }
}
::v-deep .van-picker__title {
  line-height: 80px;
}
</style>
